import React from 'react';
import { FormStack } from '../../../components/forms/FormStack';
import { HookedColorPicker } from '../../../components/forms/HookedColorPicker';
import { HookedFormField } from '../../../components/forms/HookedFormField';
import { HookedInput } from '../../../components/forms/HookedInput';

export const LocationForm = () => {
  return (
    <FormStack>
      <HookedFormField name='name' label='Name'>
        <HookedInput name='name' size='sm' placeholder='Enter a name' />
      </HookedFormField>

      <HookedFormField name='color' label='Color'>
        <HookedColorPicker name='color' mode='palette' />
      </HookedFormField>
    </FormStack>
  );
};
